// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1ClgV","inputWrap":"Table_inputWrap__1N7nM","col":"Table_col__1Liny","bmiTooltip":"Table_bmiTooltip__1BvIE"};